import React, {PropTypes} from 'react';
const eventHandler = require('./eventhandler.js');

let MyCardRecipe = React.createClass({
  createMarkup() {
    return {__html: this.props.card.preamble};
  },

  changeFilter() {
    if(this.props.category === 'recept') {
      const { recipe_type_slug, recipe_type } = this.props.card
      $("html").animate({ scrollTop: 0 }, "slow", function() {
        $('.filter-typ').val(recipe_type_slug).change();
        eventHandler.emit('filterChange');
        eventHandler.emit('filterSelectChange', {id: 'typ', value: recipe_type_slug, title: recipe_type});
      });
    }
  },

  render() {
    let author_link = '/profil/' + this.props.card.author_slug;
    let link = "/" + this.props.card.link + '/' + this.props.card.author_slug  + '/' + this.props.card.slug;
    return (
      <div className="u-padding-a-s recipe-info">
        <div className="u-margin-b-xs">
          <div className="u-float-left">
            <span className="icon icon--small icon-clock"></span>
            <span> {this.props.card.recipe_cooktime} min</span>
          </div>
          <div className={`u-float-right ${this.props.category === 'recept' ? 'recipe-category-link' : ''}`} onClick={this.changeFilter}>
            <span className="icon icon--small icon-fork u-margin-r-xs"></span>
            <span>{this.props.card.recipe_type}</span>
          </div>
        </div>
        <br />
        <h2 className="title-small u-margin-b-s">{this.props.card.title}</h2>
        <div dangerouslySetInnerHTML={this.createMarkup()}></div>
        <div className="recipe-links">
          <div className="link"><a href={author_link}>{this.props.card.author_name}</a></div>
          <div className="link" ><a href={link}>Se recept</a></div>
        </div>

      </div>
    );
  }

});

let MyCardArticle = React.createClass({
  createMarkup() {
    return {__html: this.props.card.preamble};
  },

  render() {
    let author_link = '/profil/' + this.props.card.author_slug;
    let link = "/artikel/" + this.props.card.author_slug + "/" + this.props.card.slug;

    return (
      <div className="u-padding-a-s recipe-info">
        <h2 className="u-margin-b-s title-small">{this.props.card.title}</h2>
        <div dangerouslySetInnerHTML={this.createMarkup()}></div>
        <div className="recipe-links">
          <div className="link"><a href={author_link}>{this.props.card.author_name}</a></div>
          <div className="link" ><a href={link}>Läs mer</a></div>
        </div>
      </div>
    );
  }

});

let MyCardProfile = React.createClass({
  render() {
    const name = this.props.card.name;
    let title = this.props.card.title;

    if (!title || title.length == 0) {
      title = 'Kock &amp; skribent';
    }

    return (
      <div className="u-text-center u-padding-a-m">
        <span className="u-margin-a-n title-profile">{name}</span>
        <div>{title}</div>
      </div>
    );
  }
});

let MyCard = React.createClass({

  propTypes: {

  },

  render() {
    let subCardPart = false;
    let link = "";
    let imgUrl = "";
    let corner = "";

    /*
    console.log('this.props.card.type',this.props.card.type);
    console.log('this.props.card',this.props.card);
    */

    switch(this.props.card.type){
      case 'recipe':
        link = "/" + this.props.card.link + '/' + this.props.card.author_slug  + '/' + this.props.card.slug;
        imgUrl = "/bilder/recept-hog/" + this.props.card.img_id + "/" + this.props.card.slug + ".jpg";
        corner = 'Recept';
        subCardPart = <MyCardRecipe card={this.props.card} category={this.props.category} />
        break;
      case 'article':
        link = "/" + this.props.card.link + '/' + this.props.card.author_slug  + '/' + this.props.card.slug;
        imgUrl = "/bilder/artikel-hog/" + this.props.card.img_id + "/" + this.props.card.slug + ".jpg";
        corner = 'Artikel';
        subCardPart = <MyCardArticle card={this.props.card} />
        break;
      case 'profile':
        link = '/profil/' + this.props.card.slug;
        imgUrl = '/bilder/profil-liten/' + this.props.card.id + '/' + this.props.card.slug + '.jpg';
        corner = 'Profil';
        subCardPart = <MyCardProfile card={this.props.card} />

        break;
    }

    let imgStyle = {
        backgroundImage: "url(" + imgUrl + ")"
    };

    if (subCardPart) {
      return (
        <div className="article-list-item l-grid__item desk-u-width-1-of-3 lap-u-width-1-of-2 palm-u-width-1-of-1 u-margin-b-m">
          <div className="card card-recipe 22">
            <a href={link}>
              <div className="card-thumbnail theme-light u-margin-b-s">
                {corner &&
                  <div className={'category-corner category-corner-' + corner.toLowerCase()}>
                    <div className="category-corner-triangle category-corner-triangle-band"></div>
                    <div className="category-corner-triangle category-corner-triangle-top"></div>
                    <div className="category-corner-text">{corner}</div>
                  </div>
                }
                <div className="card-thumbnail__image" style={imgStyle}></div>
              </div>
            </a>
            {subCardPart}

          </div>
        </div>
      );
    } else {
      return null;
    }
  }

});

module.exports = MyCard



// WEBPACK FOOTER //
// ./src/scripts/components/mycard.js